"use client";

import { useLayoutEffect, useRef } from "react";

import type { KundaliField } from "@/lib/analytics-kundali";

export function useInitialKundaliFieldFocus(field: KundaliField | undefined, ready: boolean) {
  const focusedField = useRef<KundaliField | null>(null);

  useLayoutEffect(() => {
    if (!ready || !field || focusedField.current === field) return;
    const input = document.getElementById(field);
    if (!(input instanceof HTMLElement)) return;
    input.focus({ preventScroll: true });
    focusedField.current = field;
  }, [field, ready]);
}
